import API from "@/api/FounderAPI"
import {idUserForApi} from "@/controllers/UserController";
import store from "@/store";
import {saveBlobFile} from "@/utils/saveFile";
import {calcDateNow} from "@/utils/date";


class FounderController {
    constructor() {
        this.api = API;
    }

    _checkId(id) {
        if (!id)
            throw new Error('id cannot be null');
    }

    /**
     * @param { Number | null | undefined } [founderId]
     * */
    async getForm2( founderId) {
        try {
            founderId = founderId ?? idUserForApi(founderId);
            this._checkId(founderId);
            const res = await this.api.read(founderId);
            const returnData = [];
            const usls = store.getters['spr/getUsls'].sort((a,b) => a.id - b.id);
            usls.forEach(el => {
                if (Object.hasOwnProperty.call(res.data, `usl${el.id}`) && res.data[`usl${el.id}`])
                    returnData.push( {id: Math.random(), uslName: el.name}, ...res.data[`usl${el.id}`]);
            });

            return returnData
        } catch (e) {
            console.error('error getForm2 ' + e.message)
            throw new Error('error getForm2 ' + e.message)
        }
    }

    /**
     * @param { Number | null | undefined } [founderId]
     * */
    async getForm2Sign( founderId) {
        try {
            founderId = founderId ?? idUserForApi(founderId);
            this._checkId(founderId);
            const res = await this.api.readSings(founderId);
            return res.data
        } catch (e) {
            console.error('error getForm2 ' + e.message)
            throw new Error('error getForm2 ' + e.message)
        }
    }

    /**
     * @param {number} rowId
     * @param {boolean} hasApprowed
     * */
    async resolveRejectOffer(rowId, hasApprowed) {
        try {
            const res =  await this.api.resolveRejectOffer(rowId, hasApprowed)
            return res.data
        } catch (e) {
            console.error('error resolveRejectOffer ' + e.message)
            throw new Error('error resolveRejectOffer ' + e.message)
        }
    }

    /**
     * @param { Number} [founderId]
     * */
    async getExcel(founderId) {
        try {
            founderId = founderId ?? idUserForApi(founderId);
            this._checkId(founderId);
            const res = await this.api.getExcel(founderId);
            saveBlobFile(res.data,`Одобрение аккредитаций ${calcDateNow()}.xlsx`,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        } catch (e) {
            console.error('error deleteRow ' + e.message)
            throw new Error('error deleteRow ' + e.message)
        }
    }

}

export default new FounderController()